import { RoutingAction } from './actions';

const initState = { routing: false };

export default function authReducer(state = initState, action: any) {
    switch (action.type) {
        case RoutingAction.SHOW_REQUEST:
            return {
                routing: true,
            };
        case RoutingAction.HIDDEN_REQUEST:
            return initState;
        default:
            return state;
    }
}
